export const en = {
  menu: {
    menuHomepage: "Homepage",
    menuPeople: "People",
    menuProjects: "Research",
    menuCourses: "Courses",
    menuGallery: "Gallery",
    menuLinks: "Publications",
    menuResources: "Resources",
    menuVegetation: "Vegetation of the Czech Republic"
  },
  footer: {
    botzool: "Department of Botany and Zoology, ",
    faculty: "Faculty of Science, ",
    university: " Masaryk University",
    postalAddressHeading: "Postal Address ",
    physicalAddressHeading: `Physical Address `,
    postalAddress: "Kotlářská 267/2, 611 37 Brno, Czech Republic",
    physicalAddress: `University Campus Bohunice, building A32, Kamenice 753/5, Brno, Czech Republic`,
    links: "Links"
  },
  gallery: {
    excursions: "Excursions",
    fieldworks: "Fieldworks"
  },
  people: {
    people: "People",
    employees: "Employees",
    phdStudents: "PhD students",
    formerPeople: "Former group members",
    visitingScientists: "Visiting Scientists (one-month and longer stays)",
    visitingScientistsShort: "Visiting Scientists"
  },
  links: {
    media: "Media",
    publications: "Publications",
    popularization: "Popularization"
  },
  mainHeader: "Vegetation Science Group",
  muni: "Masaryk university",
  up: "Up",
  showMore: "Show detail",
  showLess: "Hide detail"
};

export const cz = {
  menu: {
    menuHomepage: "Domů",
    menuPeople: "Lidé",
    menuProjects: "Výzkum",
    menuCourses: "Výuka",
    menuGallery: "Galerie",
    menuLinks: "Publikace",
    menuResources: "Zdroje",
    menuVegetation: "Vegetace České Republiky"
  },
  footer: {
    botzool: "Ústav botaniky a zoologie, ",
    faculty: "Přírodovědecká fakulta, ",
    university: " Masarykova univerzita",
    postalAddressHeading: "Korespondenční adresa ",
    physicalAddressHeading: `Adresa pracoviště `,
    postalAddress: "Kotlářská 267/2, 611 37 Brno",
    physicalAddress: `Univerzitní kampus Bohunice, budova A32, Kamenice 753/5, Brno`,
    links: "Odkazy"
  },
  gallery: {
    excursions: "Terenní exkurze",
    fieldworks: "Terenní výzkum"
  },
  people: {
    people: "Lidé",
    employees: "Zaměstnanci",
    phdStudents: "PhD studenti",
    formerPeople: "Bývalí akademičtí a výzkumní pracovníci",
    visitingScientists: "Hostující výzkumní pracovníci (pobyt delší jednoho měsíce)",
    visitingScientistsShort: "Hostující výzkumní pracovníci "
  },
  links: {
    media: "Média",
    publications: "Publikace",
    popularization: "Popularizační články"
  },
  mainHeader: "Pracovní skupina pro výzkum vegetace",
  muni: "Masarykova univerzita",
  up: "Nahoru",
  showMore: "Zobrazit detail",
  showLess: "Skrýt detail"
};
